// src/hooks/eventManager.ts
type EventCallback = (...args: any[]) => void;

class EventManager {
    private listeners: Record<string, Set<EventCallback>> = {};

    on(event: string, callback: EventCallback) {
        if (!this.listeners[event]) {
            this.listeners[event] = new Set();
        }
        this.listeners[event].add(callback);
    }

    off(event: string, callback: EventCallback) {
        if (this.listeners[event]) {
            this.listeners[event].delete(callback);
            if (this.listeners[event].size === 0) {
                delete this.listeners[event];
            }
        }
    }

    emit(event: string, ...args: any[]) {
        if (this.listeners[event]) {
            this.listeners[event].forEach(callback => callback(...args));
        }
    }
}

const eventManager = new EventManager();

export default eventManager;
